<template>
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            transitionName: ""
        };
    },
    methods: {}
};
</script>

<style lang="less">
@import "./assets/common.less";
#app {
    /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;
    // text-align: center;
    font-size: 28px;
    color: #5f6266;
    -webkit-tap-highlight-color: transparent;
    -webkit-overflow-scrolling: touch;
    // margin-top: 60px;
}
html,
body {
    margin: 0;
    padding: 0;
    background-color: #f0f2f5;
    height: 100vh;
    overflow-y: auto;   
}
// mint header样式
p,
h1 {
    padding: 0px;
    margin: 0px;
}
.mint-header {
    background-color: #ffffff;
    color: black !important;
    height: 100px;
}
.haveHeader {
    margin-top: 55px;
}
.mint-header-title {
    font-size: 36px;
}
//登录模块
.inputItem {
    margin-bottom: 30px;
    img {
        margin: 0 10px;
    }
    .sendCode {
        .flex();
        width: 90px;
        height: 30px;
        margin-left: 18px;
        background: rgba(214, 216, 219, 1);
        border-radius: 1px;
    }
    .active {
        background: rgba(40, 96, 210, 1);
    }
}
// 遮罩层
.mask {
    height: 100%;
    width: 100%;
    position: fixed;
    _position: absolute;
    top: 0;
    z-index: 99999;
    opacity: 0.8;
    filter: alpha(opacity=80);
    background-color: #000;

    .guideImg {
        width: 409px;
        height: 147px;
        position: fixed;
        top: 20px;
        right: 48px;
    }
}
//全局样式
.my_active_button {
    border: none;
    background: linear-gradient(
        180deg,
        rgba(253, 144, 38, 1),
        rgba(253, 115, 37, 1)
    );
    width: 100%;
    height: 100%;
    border-radius: 27px;
    color: #ffffff;
    font-size: 28px;
    outline: none;
}
.my_active_button_long_width {
    width: 290px;
}
.opcity_btn {
    opacity: 0.49;
}
//改变mintui toast样式
.mint-toast-text {
    font-size: 26px !important;
}

.contentBox {
    .mint-tab-item-label {
        font-size: 26px !important;
    }
    .is-selected .mint-tab-item-label {
        font-size: 32px !important;
    }
}

.p1 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.flexCC {
    display: flex;
    align-items: center;
    justify-content: center;
}

.dn {
    display: none !important;
}

.color999 {
    color: #999!important;
}

// 发表评论框
.submitCommentBox {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch; /* 解决ios滑动不流畅问题 */
    background: #fff;
    & > div {
        box-sizing: border-box;
        position: fixed;
        top: 0;
        width: 100%;
        padding: 0 28px;
        // left: 0;
        // right: 0;
        // top: 0;

        // z-index: 10;
    }

    .commentInput {
        box-sizing: border-box;
        width: 100%;
        height: 236px;
        padding: 28px 0;
        border: none;
        outline: none;
        font-size: 30px;
    }

    .commentNum {
        position: fixed;
        right: 29px;
        float: right;
        color: #999999;
        font-size: 28px;
        margin-top: -60px;
        // margin-bottom: 30px;
    }
    .btnBox {
        border-top: 1px solid #f2f2f0;
        width: 100%;
        padding-top: 40px;
        p {
            width: 120px;
            height: 60px;
            border-radius: 30px;
            font-size: 30px;
        }
        p:first-child {
            float: left;
            background: #d9d9d9;
            color: #999999;
        }
        p:last-child {
            float: right;
            background: #ffc121;
            color: #332a2a;
        }
    }
    .image-upload {
        height: 165px;
        width: 165px;
        background: url(../static/images/addImg.png) no-repeat;
        background-size: 100% 100%;
        margin-bottom: 30px;
    }
    .imgBox {
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 30px;
        // justify-content: space-between;
    }
    .imgBox-item {
        // float: left;
        height: 165px;
        width: 165px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        margin-bottom: 10px;
        margin-right: 10px;
        img {
            position: absolute;
            top: -8px;
            left: -8px;
            width: 38px;
            height: 38px;
        }
    }
    .imgBox-item:nth-child(4n + 0) {
        margin-right: 0;
    }
}

.appContent {
    .footerBox {
        bottom: 0!important;
    }
    .openAppBox {
        display: none;
    }
}
.shade .image img {
    height: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
}

// 提问-回答列表
.answerItem {
    padding: 40px 33px;
    border-bottom: 10px solid #fcfbf7;
    position: relative;

    .referenceImg {
        position: absolute;
        width: 176px;
        height: 40px;
        right: 0;
        top: 0;
    }
    .answerItem-header {
        img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 19px;
        }
        p:nth-child(2) {
            font-size: 26px;
            color: #333333;
        }
        p:nth-child(3) {
            font-size: 22px;
            color: #999;
        }
        span {
            color: #e5e5e5;
            margin: 0 10px;
        }
    }
    .content {
        font-size: 32px;
        color: #666666;
        margin-top: 32px;

        .imgBox {
            margin-top: 40px;
            display: flex;
            height: auto;
            flex-wrap: wrap;
            overflow: hidden;

            .imgBox-item{
                height: 162px;
                width: 33%;
                margin-right: 0.5%;
                margin-bottom: 2px;
                position: relative;
            }           
                        

            .imgBox-item:nth-child(3n + 0) {
                margin-right: 0;
            }

            .imgBorderRadius {
                // border-bottom-right-radius: 8px;
                // border-top-right-radius: 8px;
            }
        }
    }
    .bottom {
        margin-top: 35px;
        height: 38;
        display: flex;
        align-items: center;

        img {
            width: 38;
            height: 38px;
            margin-right: 20px;
        }

        span {
            color: #7b7b7b;
            font-size: 26px;
        }

        .bottomItem {
            margin-right: 96px;
            display: flex;
            align-items: center;
        }
    }
}
.answerItem:last-child {
    margin-bottom: 0;
}


.pe1 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}


// 图片自适应
.imgAuto {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
}

// 禁止元素点击事件触发
.banClick a {
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue